/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5b9c855c"]'><div><div :class='["picker-demo-title"]'>Use format:</div><cube-date-picker :min="(min)" :max="(max)" :value="(value)" :format="(format)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_5b9c855c"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5b9c855c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5b9c855c"}
  /** script content **/
  require("./formate-picker.mpx.js?isComponent&outputPath=components%2Fformate-picker5b9c855c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./formate-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fformate-picker5b9c855c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5b9c855c"],
    ctorType: "component",
    outputPath: "components/formate-picker5b9c855c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>